import { createAsyncThunk as baseCreateAsyncThunk } from '@reduxjs/toolkit';
import { useSelector as useBaseSelector, useDispatch as useBaseDispatch } from 'react-redux';

import type { RootState, AppDispatch } from './store';

export type ThunkApiConfig = {
  state: RootState;
  dispatch: AppDispatch;
  rejectValue: unknown;
};

export const useSelector = useBaseSelector.withTypes<RootState>();
export const useDispatch = useBaseDispatch.withTypes<AppDispatch>();
export const createAsyncThunk = baseCreateAsyncThunk.withTypes<ThunkApiConfig>();
